module.exports = __webpack_public_path__ + "img/RedEnvelope.7912ab6c.png";